import { render, staticRenderFns } from "./product-counter.vue?vue&type=template&id=07d553bd&scoped=true"
import script from "./product-counter.vue?vue&type=script&lang=js"
export * from "./product-counter.vue?vue&type=script&lang=js"
import style0 from "./product-counter.vue?vue&type=style&index=0&id=07d553bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d553bd",
  null
  
)

export default component.exports